import { render, staticRenderFns } from "./fwUpdateNotice.vue?vue&type=template&id=46fa929a"
import script from "./fwUpdateNotice.vue?vue&type=script&lang=js"
export * from "./fwUpdateNotice.vue?vue&type=script&lang=js"
import style0 from "./fwUpdateNotice.vue?vue&type=style&index=0&id=46fa929a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports